import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { GetHrAppraisalFormInfoModel } from "features/hr/core/domain/hr-appraisal-form-info.model";
import {
  GetHrAppraisalFormInfoRepository,
  GetHrAppraisalFormInfoResponse,
} from "features/hr/data/repository/hr-appraisal.repository";
import { RootState } from "features/config/store";

export enum GetHrAppraisalFormInfoState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetHrAppraisalFormInfoState;
  message: string;
  data: GetHrAppraisalFormInfoModel | undefined;
}

const initialState: InitialState = {
  status: GetHrAppraisalFormInfoState.initial,
  message: "",
  data: undefined,
};

export const getHrAppraisalFormInfo = createAsyncThunk(
  "getHrAppraisalFormInfo",
  async (appraisal_responses_type_id: number, { rejectWithValue }) => {
    try {
      const response: GetHrAppraisalFormInfoResponse =
        await GetHrAppraisalFormInfoRepository(appraisal_responses_type_id);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const getHrAppraisalFormInfoSlice = createSlice({
  name: "getHrAppraisalFormInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHrAppraisalFormInfo.pending, (state) => {
        state.status = GetHrAppraisalFormInfoState.inProgress;
      })
      .addCase(getHrAppraisalFormInfo.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetHrAppraisalFormInfoState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getHrAppraisalFormInfo.rejected, (state, action) => {
        state.status = GetHrAppraisalFormInfoState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetHrAppraisalFormInfo = (state: RootState) =>
  state.getHrAppraisalFormInfo;

export default getHrAppraisalFormInfoSlice.reducer;
